<template>
  <van-popup v-model="visible" position="bottom" :overlay="true" :style="{ height: '40%' }">
    <div class="popup-content">
      <div class="popup-header">
        <div class="popup-action" @click="visible=false">取消</div>
        <div class="popup-title">更换店员</div>
        <div class="popup-action" @click="confirm">确认</div>
      </div>
      <div class="popup-item">
        <van-field v-model="updateClerkName" is-link readonly label="更换店员" placeholder="请选择店员" @click="replaceClerk()"/>
      </div>
      <div class="popup-item">
        <van-field
            v-model="remark"
            rows="2"
            autosize
            label="留言"
            type="textarea"
            maxlength="100"
            placeholder="请输入留言"
            show-word-limit/>
      </div>
    </div>
    <!-- 更换店员上拉菜单 -->
    <van-popup v-model="replaceClerkShow" position="bottom" :overlay="true">
      <van-cell-group>
        <van-field v-model.trim="clerkName" placeholder="搜索店员" input-align="center"
                   clearable @input="selectClerkName" left-icon="search"/>
      </van-cell-group>
      <!-- 选择器 -->
      <van-picker
          show-toolbar
          :columns="columns"
          @cancel="replaceClerkShow = false"
          @confirm="onConfirmReplaceClerk"/>
    </van-popup>
  </van-popup>
</template>

<script>
import Vue from 'vue';
import {Dialog, Popup, Toast} from 'vant';
import {replaceOrderClerk, getClerkList} from '@/api/kf/order'

Vue.use(Popup)

export default {
  name: "order-change-clerk",
  data() {
    return {
      visible: false,
      orderId: false,
      remark: null,

      replaceClerkShow: false,
      clerkName: '',
      searchList: [],

      updateClerkName:null,
      updateClerkId:null,
    }
  },
  methods: {
    show(orderId) {
      this.visible = true
      this.orderId = orderId
    },
    /**更换店员*/
    confirm(){
      // 弹出框
      let message = '确认更换为【' + this.updateClerkName + '】吗？'
      Dialog.confirm({title: '提示', message: message,}).then(() => {
        Toast.loading({mask: true, message: '加载中...'})
        // 更换店员
        replaceOrderClerk(this.orderId, this.updateClerkId, this.remark).then((res) => {
          Toast.clear()
          const data = res.data
          if (data.code == 0) {
            this.$emit('on-success');
            Toast.success('更换成功')
          } else {
            Toast.fail(data.msg)
          }
        })
        // 关闭上拉菜单
        this.visible = false
      }).catch(() => {
      })
    },
    /** 搜索店员 */
    selectClerkName() {
      if (this.clerkName != '') {
        // 清空搜索list
        this.searchList = []
        // 遍历
        for (const item of this.columnsTemp) {
          // 筛选条件
          if (item.text.indexOf(this.clerkName) != -1) {
            // 添加到搜索list
            this.searchList.push(item)
          }
        }
        if (this.searchList.length > 0 || !this.searchList.isEmpty) {
          this.columns = this.searchList
        }
      } else {
        this.columns = this.columnsTemp
      }
    },
    replaceClerk() {
      this.columns = []
      Toast.loading({
        mask: true,
        message: '加载中...'
      })
      this.replaceClerkShow = true
      // 加载店员列表
      getClerkList().then(res => {
        Toast.clear()
        const data = res.data
        if (data.code == 0) {
          // 遍历
          for (const item of data.list) {
            // 数组变异
            this.columns.push({text: item.name, id: item.id})
          }
          // 保存到临时list中，搜索时需要用到
          this.columnsTemp = this.columns
        } else {
          Dialog.alert({
            title: '加载' + this.$store.state.label.clerkLabel + '列表失败',
            message: data.msg
          })
        }
      })
    },
    /** 确认更换店员 */
    onConfirmReplaceClerk(value) {
      this.updateClerkId=value.id
      this.updateClerkName=value.text
        // 关闭上拉菜单
      this.replaceClerkShow = false
    },

  },
}
</script>

<style lang="less" scoped>
.popup-content {
  padding: 0 20px;
}

.popup-header {
  display: flex;
  margin: 15px;
  justify-content: space-between;
  align-items: center;
}

.popup-action {
  color: #3388FF;
  text-align: left;
}

.popup-title {
  text-align: center;
  font-weight: bolder;
}

.popup-item {
  border-bottom: 1px solid #cccccc;
  margin: 10px 0;
}
</style>
